export default "__VITE_ASSET__CQWKGMl___"